import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { IconButton } from '../primitives/IconButton';
import { useTheme } from '../theme/useTheme';
function SunIcon() {
    return (_jsxs("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: [_jsx("circle", { cx: "12", cy: "12", r: "4" }), _jsx("path", { d: "M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" })] }));
}
function MoonIcon() {
    return (_jsx("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: _jsx("path", { d: "M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" }) }));
}
/**
 * Hell/Dunkel-Umschalter fuer die App-Shell. Schaltet ueber `useTheme()` zwischen
 * `light` und `dark` (der `ThemeProvider` setzt `data-sec-theme`; die Dark-Tokens
 * stammen aus `@sectepe/design-system`) und persistiert die Wahl in
 * `localStorage` unter `persistKey`. Beim Start liest die App diese Praeferenz
 * typischerweise als `defaultTheme` des Providers wieder ein.
 *
 * Muss innerhalb eines `<ThemeProvider>` gerendert werden.
 */
export function ThemeToggle({ persistKey = 'sec-theme', className, style, labelToLight = 'Zum hellen Modus wechseln', labelToDark = 'Zum dunklen Modus wechseln', } = {}) {
    const { resolvedTheme, setTheme } = useTheme();
    const isDark = resolvedTheme === 'dark';
    const toggle = useCallback(() => {
        const next = isDark ? 'light' : 'dark';
        setTheme(next);
        try {
            window.localStorage.setItem(persistKey, next);
        }
        catch {
            /* localStorage optional (Privatmodus o. Ae.) */
        }
    }, [isDark, setTheme, persistKey]);
    return (_jsx(IconButton, { "aria-label": isDark ? labelToLight : labelToDark, title: isDark ? 'Heller Modus' : 'Dunkler Modus', className: className, style: style, onClick: toggle, children: isDark ? _jsx(SunIcon, {}) : _jsx(MoonIcon, {}) }));
}
